// src/components/LeftPanel.jsx
import React from "react";
import styled, { keyframes } from "styled-components";
import LogoLeftImage from "../../../assets/design/CLIDE SURVEY GRAPH.gif";
import BannerImageCarousel from "./bannerImageCarousel";

const hexToRgba = (hex, opacity) => {
  if (!hex) return `rgba(245, 102, 32, ${opacity})`;
  hex = hex.replace(
    /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
    (_, r, g, b) => r + r + g + g + b + b,
  );
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? `rgba(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}, ${opacity})`
    : `rgba(245, 102, 32, ${opacity})`;
};

const floatUpDown = keyframes`
  0%, 100% { transform: translateY(0); }
  50%      { transform: translateY(-8px); }
`;

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(12px) scale(0.98); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
`;

const LogoImage = styled.img`
  width: 300px;
  max-width: 100%;
  height: auto;
  max-height: 15vh;
  object-fit: contain;
  margin-bottom: 2vh;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 58%;
  padding: 2vh 3rem;
  position: relative;
  overflow: hidden;
  background: radial-gradient(circle at center, ${({ $themeColor }) => hexToRgba($themeColor, 0.38)} 0%, #ffffff 55%);

  @media (max-width: 1200px) {
    width: 100%;
    padding: 2rem 1.5rem;
  }
`;

const BannerImage = styled.img`
  width: 92%;
  max-width: 540px;
  max-height: calc(100vh - 240px);
  object-fit: contain;
  filter: drop-shadow(0 12px 32px rgba(0, 0, 0, 0.06));
  opacity: 0;
  animation: ${fadeIn} 0.8s cubic-bezier(0.22, 1, 0.36, 1) forwards,
             ${floatUpDown} 3.5s ease-in-out 0.8s infinite;
`;

const PoweredText = styled.p`
  font-size: 12px;
  line-height: 1.6;
  color: #a1a1aa;
  margin-top: 16px;
  margin-bottom: 0;
  letter-spacing: 0.02em;
  opacity: 0;
  animation: ${fadeIn} 0.6s cubic-bezier(0.22, 1, 0.36, 1) 0.5s forwards;

  & strong {
    color: ${({ $themeColor }) => $themeColor || "#f56620"};
    font-weight: 600;
  }
`;

const LeftPanel = ({
  themeColor,
  leftPanelLogo,
  carouselBannerImages,
  carouselAutoscrollEnabled,
}) => {
  return (
    <Wrapper $themeColor={themeColor}>
      {/* Company Logo */}
      {leftPanelLogo && (
        <LogoImage
          src={leftPanelLogo}
          alt="Company Logo"
          className="company-logo"
        />
      )}

      {carouselBannerImages && carouselBannerImages.length > 0 ? (
        <BannerImageCarousel
          themeColor={themeColor}
          leftPanelLogo={leftPanelLogo}
          carouselBannerImages={carouselBannerImages}
          carouselAutoscrollEnabled={carouselAutoscrollEnabled}
        />
      ) : (
        <BannerImage src={LogoLeftImage} alt="CLIDE Survey Analytics" />
      )}

      <PoweredText $themeColor={themeColor}>
        Powered by <strong>CLIDE Analyser</strong>
      </PoweredText>
    </Wrapper>
  );
};

export default LeftPanel;
